import { useParams } from "react-router-dom";
import { useAppData } from "@/data/AppDataContext";
import { PortalLayout } from "@/components/portal/PortalLayout";
import { ContractorRatingPanel } from "@/components/portal/ContractorRatingPanel";
import { AlertCircle, Loader2 } from "lucide-react";
import { CloseoutService } from "@/services/closeout.service";

export default function ContractorRatingPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const { jobs } = useAppData();

  const job = jobs.find((j) => j.id === jobId);

  if (!job) {
    return (
      <PortalLayout>
        <div className="flex flex-col items-center justify-center py-20">
          <Loader2 className="h-12 w-12 animate-spin text-muted-foreground/40 mb-4" />
          <p className="text-sm text-muted-foreground">Loading project...</p>
        </div>
      </PortalLayout>
    );
  }

  const handleRatingSubmitted = async () => {
    await CloseoutService.markContractorRatingCompleted(job.id);
  };

  return (
    <PortalLayout>
      <div className="max-w-md mx-auto pt-12">
        <ContractorRatingPanel job={job} onRatingSubmitted={handleRatingSubmitted} />
      </div>
    </PortalLayout>
  );
}